"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForgotEmail = exports.useGetAnnouncements = exports.useUnsubscribeFromPushNotifications = exports.useSubscribeToPushNotifications = exports.useRegisterVerification = exports.useRegisterSelection = exports.useChangePharmacy = exports.useResetPassword = exports.useForgotPassword = exports.useUpdateUser = exports.useRegister = exports.useDeleteUser = exports.useChangePassword = void 0;
var user_1 = require("../user");
var react_query_1 = require("react-query");
function useChangePassword(options) {
    return (0, react_query_1.useMutation)(user_1.changePassword, options);
}
exports.useChangePassword = useChangePassword;
function useDeleteUser(options) {
    return (0, react_query_1.useMutation)(user_1.deleteUser, options);
}
exports.useDeleteUser = useDeleteUser;
function useRegister(options) {
    return (0, react_query_1.useMutation)(user_1.register, options);
}
exports.useRegister = useRegister;
function useUpdateUser(options) {
    return (0, react_query_1.useMutation)(user_1.updateUser, options);
}
exports.useUpdateUser = useUpdateUser;
function useForgotPassword(options) {
    return (0, react_query_1.useMutation)(user_1.getForgotPassword, options);
}
exports.useForgotPassword = useForgotPassword;
function useResetPassword(options) {
    return (0, react_query_1.useMutation)(user_1.postForgotPassword, options);
}
exports.useResetPassword = useResetPassword;
function useChangePharmacy(options) {
    return (0, react_query_1.useMutation)(user_1.changePharmacy, options);
}
exports.useChangePharmacy = useChangePharmacy;
function useRegisterSelection(options) {
    return (0, react_query_1.useMutation)(user_1.registerSelection, options);
}
exports.useRegisterSelection = useRegisterSelection;
function useRegisterVerification(options) {
    return (0, react_query_1.useMutation)(user_1.registerVerification, options);
}
exports.useRegisterVerification = useRegisterVerification;
function useSubscribeToPushNotifications(options) {
    return (0, react_query_1.useMutation)(user_1.subscribeToPushNotifications, options);
}
exports.useSubscribeToPushNotifications = useSubscribeToPushNotifications;
function useUnsubscribeFromPushNotifications(options) {
    return (0, react_query_1.useMutation)(user_1.unsubscribeFromPushNotifications, options);
}
exports.useUnsubscribeFromPushNotifications = useUnsubscribeFromPushNotifications;
function useGetAnnouncements() {
    return (0, react_query_1.useQuery)(["getAnnouncements"], user_1.getAnnouncements);
}
exports.useGetAnnouncements = useGetAnnouncements;
function useForgotEmail(options) {
    return (0, react_query_1.useMutation)(user_1.forgotEmail, options);
}
exports.useForgotEmail = useForgotEmail;
